import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	tabRoot: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
	},
	tabList: {
		marginBottom: '1em',
	},
	tabContent: {
		flex: 1,
		overflow: 'hidden',
	},
});
